import { mapState } from 'vuex';
import { handleLocalStorage, routerJump } from '@/assets/js/utils.js';
export default {
  data() {
    return {
      text: '',
      passWord: '',
      partyCode: '',
      isNeedPassCode: false,
      buttonText: this.$t('partylineGuest.backHome'),
      title: this.$t('partylineGuest.leave'),
      module: ''
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      homeLogo: state => state.homeLogo
    })
  },
  created() {
    const {
      type,
      number,
      partyCode
    } = this.$route.query;
    this.module = type;
    switch (type) {
      case 'end':
        this.text = this.$t('partylineGuest.endPartyNotice');
        break;
      case 'cancelCohost':
        this.text = this.$t('addWords.cancelCohost');
        break;
      case 'fullParty':
        this.title = this.$t('addWords.failToJainParty');
        this.text = this.$t('addWords.fullParty') + `${number}`; // kiosk模式有不同的layout
        break;
      case 'noCommonpartyPermission':
        this.title = this.$t('addWords.noPermission');
        this.text = this.$t('addWords.accountNotAllowed');
        break;
      case 'needPassCode':
        this.partyCode = partyCode;
        this.isNeedPassCode = true;
        this.buttonText = this.$t('start.join');
        this.title = this.$t('addWords.participantPassCode');
        this.text = this.$t('addWords.caseSensitive');
        break;
      case 'limitation':
        this.title = this.$t('addWords.failToJainParty');
        this.text = this.$t('partylineGuest.limitation');
        break;
      case 'disableParty':
        this.title = this.$t('partyInfo.unableJoin');
        this.text = this.$t('partyInfo.partyDisable');
        break;
      case 'notExist':
        this.title = this.$t('partyInfo.unableJoin');
        this.text = this.$t('partyInfo.deletedParty');
        break;
      case 'cancelInvite':
        this.title = this.$t('partyInfo.unableJoin');
        this.text = this.$t('partyInfo.cancelInvited');
        this.partyCode = partyCode;
        this.buttonText = this.$t('partyInfo.rejoin');
        break;
      default:
        this.text = this.$t('partylineGuest.removeFromParty');
    }
  },
  methods: {
    jump() {
      if (this.isNeedPassCode) {
        this.judgePassWord();
      } else {
        if (this.module === 'cancelInvite') {
          routerJump('preview', {
            id: this.partyCode
          });
        } else {
          routerJump('joinOrStart', {
            passWord: this.passWord
          });
        }
      }
    },
    judgePassWord() {
      var _this$partyCode;
      let haveHistoryMem = '';
      if (((_this$partyCode = this.partyCode) === null || _this$partyCode === void 0 ? void 0 : _this$partyCode.length) == 16) {
        haveHistoryMem = handleLocalStorage('get', 'galleryMemberId');
      } else {
        haveHistoryMem = handleLocalStorage('get', 'memberId');
      }
      if (!this.partyCode) return;
      const params = {
        partyCode: this.partyCode,
        invitePassCode: this.passWord,
        memberId: haveHistoryMem
      };
      this.axios.post('/partyline-backend/partyExtendInfo/noLogin/checkInvite', params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          routerJump('participate', {
            passWord: this.passWord,
            join_id: this.partyCode
          });
        } else {
          this.$message.error('Incorrect password');
        }
      });
    }
  }
};